<template>
  <template
    v-for="(option, idx) in options"
    :key="option?.text || idx"
  >
    <range-element-fi
      v-if="option"
      :class="{
        'fact-finder-range-filter-fi': true,
      }"
      :option="option"
      :filter="filter"
      @change="onChange"
    />
  </template>
</template>

<script setup lang="ts">
import { throttle } from 'throttle-debounce';
import { computed, onMounted } from 'vue';

import type { ProcessedFactFinderNgFacet } from '@/components/facets/processedFacetTypes.ts';
import type { SearchFilter } from '@/components/search-fact-finder-results-fi/SearchFactFinderResultsFi.vue';

import RangeElementFi from './range-element-fi/RangeElementFi.vue';

defineOptions({
  name: 'FactFinderRangeFilterFi',
});

const props = defineProps<{
  filter: ProcessedFactFinderNgFacet;
}>();

const emits = defineEmits<{
  'filter-changed': [filter: SearchFilter];
}>();

let throttledOnChange: (element: SearchFilter) => void = () =>
  console.debug('throttle called before initialization');

onMounted(() => {
  throttledOnChange = throttle(500, onApply);
});

const options = computed(() => {
  return props.filter.elements;
});

const onChange = (element: SearchFilter) => {
  throttledOnChange(element);
};

const onApply = (element: SearchFilter) => {
  emits('filter-changed', element);
};
</script>

<style scoped src="./fact-finder-range-filter-fi" />
